import { render, staticRenderFns } from "./BaseTeacherListTeacherStatistics.vue?vue&type=template&id=c8cb95fc&scoped=true"
import script from "./BaseTeacherListTeacherStatistics.vue?vue&type=script&lang=js"
export * from "./BaseTeacherListTeacherStatistics.vue?vue&type=script&lang=js"
import style0 from "./BaseTeacherListTeacherStatistics.vue?vue&type=style&index=0&id=c8cb95fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cb95fc",
  null
  
)

export default component.exports